import { combineReducers } from "redux";
import { History } from "history";
import { connectRouter } from "connected-react-router";
import auth, { AuthState } from "./auth";
import flashes, { FlashesState } from "./flashes";
import chat, { ChatState } from "./chat";
import social, { SocialState } from "./social";
import clubs, { ClubsState } from "./clubs";
import club, { ClubState } from "./club";
import map, { MapState } from "./map";
import utility, { UtilityState } from "./utility";
import visibility, { VisibilityState } from "./visibility";
import reservation, { ReservationState } from "./reservation";
import stats, { StatsState } from "./stats";
import locations, { LocationsState } from "./locations";
import profile, { ProfileState } from "./profile";
import clubPlayerCounts, { ClubPlayerCountsState } from "./clubPlayerCounts";
import playerModal, { PlayerModalState } from "./playerModal";
import playerRatingModal, { OfficialRatingState } from "./playerRatingModal";
import leaderboardModal, { LeaderboardState } from "./leaderboardModal";
import deals, { DealsState } from "./deals";
import typing, { TypingState } from "./typing";
import championships, { ChampionshipsState } from "./championships";
import cards, { CardsState } from "./cards";
import timezones, { TimezonesState } from "./timezones";
import ipLocation, { IPLocationState } from "./ipLocation";
import inviteModal, { InviteState } from "./inviteModal";
import playerChampionshipModal, { PlayerChampionshipModalState } from "./playerChampionshipModal";
import challengeLeaderboardModal, { ChallengeLeaderboardState } from "./challengeLeaderboardModal";

export type RootState = {
	auth: AuthState;
	profile: ProfileState;
	flashes: FlashesState;
	chat: ChatState;
	social: SocialState;
	club: ClubState;
	clubs: ClubsState;
	map: MapState;
	visibility: VisibilityState;
	utility: UtilityState;
	reservation: ReservationState;
	stats: StatsState;
	locations: LocationsState;
	clubPlayerCounts: ClubPlayerCountsState;
	playerModal: PlayerModalState;
	playerChampionshipModal: PlayerChampionshipModalState;
	playerRatingModal: OfficialRatingState;
	inviteModal: InviteState;
	leaderboardModal: LeaderboardState;
	challengeLeaderboardModal: ChallengeLeaderboardState;
	deals: DealsState;
	typing: TypingState;
	championships: ChampionshipsState;
	cards: CardsState;
	timezones: TimezonesState;
	ipLocation: IPLocationState;
	router: any;
};

export type RootReducer = typeof rootReducer;
const rootReducer = (history: History) =>
	combineReducers({
		router: connectRouter(history),
		auth,
		profile,
		flashes,
		chat,
		social,
		club,
		clubs,
		map,
		visibility,
		utility,
		reservation,
		stats,
		locations,
		clubPlayerCounts,
		playerModal,
		playerChampionshipModal,
		playerRatingModal,
		leaderboardModal,
		challengeLeaderboardModal,
		inviteModal,
		deals,
		typing,
		championships,
		cards,
		timezones,
		ipLocation,
	});

export default rootReducer;
